module.exports = "https://www.gc-pro.gnp.com.mx/f95d68cfcfff2ff4ce9ea437a5afcf56.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/recuperar-contrasena/2.png
// module id = 1045
// module chunks = 0 1